import { clsx } from 'clsx';

/**
 * Single-select status filter pill. Used on both the plays page and the
 * trader detail page so the visual language stays consistent: muted text +
 * surface bg when inactive, status-coloured text + tinted bg when active.
 */
export function StatusFilterPill({
  active,
  onClick,
  children,
  colorClass,
  activeBgClass,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
  colorClass: string;
  activeBgClass: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        'px-3 py-1.5 rounded text-xs font-mono font-medium transition-colors',
        colorClass,
        active ? activeBgClass : 'bg-surface-2 hover:bg-surface-3',
      )}
    >
      {children}
    </button>
  );
}
